/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_Never_UsedInputs */

const en_settings_keys_never_used = /** @type {(inputs: Settings_Keys_Never_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never used`)
};

const id_settings_keys_never_used = /** @type {(inputs: Settings_Keys_Never_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum pernah dipakai`)
};

/**
* | output |
* | --- |
* | "Never used" |
*
* @param {Settings_Keys_Never_UsedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_never_used = /** @type {((inputs?: Settings_Keys_Never_UsedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_Never_UsedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_never_used(inputs)
	return en_settings_keys_never_used(inputs)
});